const AUTH_URL = `${import.meta.env.VITE_BACKEND_URL}/api/v1/auth`

/** What the signed query carries; the server signs it, the pages only pass it back untouched. */
export function readOAuthQuery(): {
  oauthQuery: string
  clientId: string | null
  redirectHost: string | null
} {
  const oauthQuery = window.location.search.replace(/^\?/, '')
  const params = new URLSearchParams(oauthQuery)
  let redirectHost: string | null = null
  try {
    const redirectUri = params.get('redirect_uri')
    if (redirectUri) redirectHost = new URL(redirectUri).host
  } catch {
    redirectHost = null
  }
  return { oauthQuery, clientId: params.get('client_id'), redirectHost }
}

/** The name a client gave itself when it registered. Plain text only: it is not trusted. */
export async function fetchClientName(clientId: string): Promise<string | null> {
  const response = await fetch(
    `${AUTH_URL}/oauth2/public-client?client_id=${encodeURIComponent(clientId)}`,
    { credentials: 'include' }
  )
  if (!response.ok) return null
  const client = (await response.json()) as { client_name?: string }
  return typeof client.client_name === 'string' ? client.client_name : null
}

/** Accept or deny the connection; the server answers with where to send the browser next. */
export async function submitConsent(accept: boolean, oauthQuery: string): Promise<string> {
  const response = await fetch(`${AUTH_URL}/oauth2/consent`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ accept, oauth_query: oauthQuery }),
  })
  if (!response.ok) throw new Error('consent_failed')
  const result = (await response.json()) as { url?: string }
  if (!result.url) throw new Error('consent_failed')
  return result.url
}

/** The server's authorize endpoint for the assistant's signed request: resumes it once signed in. */
export function authorizeUrl(oauthQuery: string): string {
  return `${AUTH_URL}/oauth2/authorize?${oauthQuery}`
}
